<template>
  <div class="page-builder-layout">
    <main-head-component/>
    <page-builder-slot>
      <component
        v-for="(item, index) in components_data"
        :is="item.component_name_kebab"
        v-bind="item.component_data"
        :key="`builder-component_${index}`"/>
    </page-builder-slot>
    <footer-component/>
  </div>
</template>

<script>

import FooterComponent from "../parts/FooterComponent.vue";
import PageBuilderSlot from "../slots/PageBuilderSlot.vue";
import MainHeadComponent from "../builder_components/MainHeadComponent.vue";
import pixel_mixin from "../../mixins/pixel_mixin";

export default {
  name: "PageBuilderLayout",
  mixins: [pixel_mixin],
  components: {
    MainHeadComponent,
    PageBuilderSlot,
    FooterComponent,
  },
  computed: {
    item() {
      return this.$context?.item || {}
    },
    components_data() {
      return this.item.components || []
    },

  },
}
</script>
